export const contacts = {
  contactInfo: '联系人信息',
  confirmDeleteMember: '是否将该成员从团队中删除？',
  teamMemberInvitation: '团队成员邀请',
  clickToJoinTeam: '点击进入链接加入团队',
  addContact: '添加联系人',
  shareToWeChat: '分享到微信',
  copyInvitationLink: '复制邀请链接',
  shareToWeChatFriends: '点击右上角分享给微信好友',
  linkValidityPeriod: ' 该分享7天内（{month}月{day}日前）有效，且仅对{num}人有效',
  projectMembers: '项目成员',
  selectResponsiblePerson: '选择负责人',
  addParticipant: '添加参与人',
  selectParticipant: '选择参与人',
  projectManager: '负责人',
  projectParticipants: '参与人',
  chooseOne: '请选择1位',
  creator: '创建人',
  setPermission: '设置权限',
  confirmDeleteMemberInProduct: '是否将该成员从项目中删除？',
  responsibleProgress: '负责进度',
  inviteMember: '邀请成员',
  addMember: '添加成员',
  setRolePermissions: '设置角色&权限',
  selectRole: '选择角色',
  projectInvitation: '项目邀请',
  clickToJoinProject: '点击进入链接加入项目',
  onlyAddOneOwner: '仅可添加一位业主',
  enterNumberOfPeople: '请输入人数',
  enterNumberOfPeopleToShare: '请输入要分享的人数',
  selectContact: '选择联系人',
  noTeamMembers: '暂无团队成员'
};
